import { combineReducers } from 'redux';
import { orderReducer } from './order/reducers';
import { selectedServicesReducer } from './selectedServices/reducers';
import servicesSavingReducer from './servicesLoading/reducer';
import { seatMapReducer } from '../../../SeatMap/store/reducers';
import { errorReducer } from '@entities/error';
import { restrictionsReducer } from '@entities/restrictions';
import { orderReducer as newOrderReducer } from '@entities/order';
export const rootReducer = combineReducers({
    order: orderReducer,
    newOrder: newOrderReducer,
    selectedServices: selectedServicesReducer,
    servicesLoading: servicesSavingReducer,
    seatMap: seatMapReducer,
    restrictions: restrictionsReducer,
    error: errorReducer
});
